import React from 'react';
import GameBottom from '../gameBottom';

const MainGameWrapper = ({children}) =>{
  return (
    <div className="main-game-wrp">
      <div className="main-center-wrp">
        {children}
      </div>
    </div>
  )
};
export default MainGameWrapper
